import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "systems" }
const _hoisted_2 = { class: "big-list" }
const _hoisted_3 = { class: "big-list--filter" }
const _hoisted_4 = { class: "count" }

import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Actions } from '@/store';
import { HardwareComponent } from '@/models/hardware.model';
import { System as SystemModel } from '@/models/system.model';
import HardwareComponentItem from '@/components/hardware/HardwareComponentItem.vue';
import System from '@/components/system/System.vue';
import ListFilter from '@/components/list-filter/ListFilter.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HardwareComponentList',
  setup(__props) {

const store = useStore();
const router = useRouter();
const systems = computed<SystemModel[]>(() => store.state.systems);
const filteredHardware = computed<HardwareComponent[]>(
  () => store.getters.filteredHardware,
);
const hardwareCount = computed(() => {
  return `${filteredHardware.value.length} Item${
    filteredHardware.value.length === 1 ? '' : 's'
  }`;
});

onMounted(() => {
  store.dispatch(Actions.GetSystems);
  store.dispatch(Actions.GetHardwareConfiguration);
  store.dispatch(Actions.GetHardwareComponents);
});

const add = () => {
  router.push('/hardware/add');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(systems), (system) => {
        return (_openBlock(), _createBlock(System, {
          key: system.slug,
          system: system
        }, null, 8, ["system"]))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(hardwareCount)), 1),
        _createVNode(ListFilter),
        _createElementVNode("button", {
          type: "button",
          onClick: add
        }, "Add")
      ]),
      _createElementVNode("ol", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredHardware), (item) => {
          return (_openBlock(), _createBlock(HardwareComponentItem, {
            item: item,
            key: item.key
          }, null, 8, ["item"]))
        }), 128))
      ])
    ])
  ]))
}
}

})